import itemChange from 'owa-service/lib/factory/itemChange';
import ItemId from 'owa-service/lib/contract/ItemId';
import updateItemOperation from 'owa-service/lib/operation/updateItemOperation';
import updateItemRequest from 'owa-service/lib/factory/updateItemRequest';
import UpdateItemResponse from 'owa-service/lib/contract/UpdateItemResponse';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
import createSetItemField from 'owa-mail-store/lib/services/utils/createSetItemField';
import itemId from 'owa-service/lib/factory/itemId';

function createRequestBody(itemIdToUpdate: ItemId, reactionType: string) {
    const changeToItem = itemChange({
        Updates: [createSetItemField('OwnerReactionType', reactionType)],
        ItemId: itemId({ Id: itemIdToUpdate.Id, ChangeKey: itemIdToUpdate.ChangeKey }),
    });

    return updateItemRequest({
        ItemChanges: [changeToItem],
        ConflictResolution: 'AlwaysOverwrite',
        MessageDisposition: 'SaveOnly',
    });
}

/**
 * Reacts to an Item
 * @param itemIdToUpdate Item id to be updated
 * @param reactionType The reaction type
 */
export default function reactToItemService(
    itemIdToUpdate: ItemId,
    reactionType: string
): Promise<UpdateItemResponse> {
    const requestBody = createRequestBody(itemIdToUpdate, reactionType);
    const jsonRequestHeader = getJsonRequestHeader();
    jsonRequestHeader.TimeZoneContext.TimeZoneDefinition.Id = 'UTC';

    return updateItemOperation({
        Header: jsonRequestHeader,
        Body: requestBody,
    }).then(response => {
        return response.Body.ResponseMessages.Items[0];
    });
}
